
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    TextField,
    FormControl,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {RecordTypeModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export const RecordTypeSelectorComponent: React.FC<{
  selectedRecordType: RecordTypeModel | null,
  availableRecordTypes: RecordTypeModel[],
  selectRecordType: (thisRecordType: RecordTypeModel) =>  void
}> = ( {
  selectedRecordType,
  availableRecordTypes,
  selectRecordType
}) => {

  const styles = ContainerClasses();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const recordUuid = event.target.value;
    const thisRecordType = availableRecordTypes.find((thisType) => thisType.Uuid_sys == recordUuid)
    if(thisRecordType){
      selectRecordType(thisRecordType)
    }
  };

  return (
    <FormControl>
       <FormLabel> Record Type </FormLabel>

       <RadioGroup
          value = {selectedRecordType?.Uuid_sys}
          onChange = {(e) => handleChange(e)}
       >
          {
            availableRecordTypes.map((thisRecordType) => {
               return <FormControlLabel
                         value={thisRecordType.Uuid_sys}
                         label={thisRecordType.Label_sys}
                         control={<Radio />}
                      />
                    })
          }
      </RadioGroup>

  </FormControl>
);
};
